import * as React from "react";
import {useCallback, useMemo} from "react";
import {useAppDispatch} from "store";
import {Grid} from "@mui/material";
import {Formik, FormikProps} from "formik";
import {QuillEditorField} from "components/form/QuillEditorField";
import {HtmlType, VersionsType} from "helpers/editorTest";
import {updateEditorElement} from "store/editorTest";
import {ContentEditorElementIndexResponse} from "generated-api";
import {isApiResultError} from "../../helpers/api";
import {debounce} from "@mui/material/utils";
import {quillGetValue, quillSetValue} from "utils/quill";


interface EditorHtmlFormFieldsProps {
    formikProps: FormikProps<HtmlType>;
    disabled: boolean;
}

const EditorHtmlFormFields = (props: EditorHtmlFormFieldsProps) => {
    const {formikProps, disabled} = props;
    const {handleSubmit} = formikProps;

    const autoSubmit = useMemo(
        () => debounce(() => {
            void handleSubmit();
        }, 3000),
        [handleSubmit]
    );

    return <form onSubmit={handleSubmit}>
        <Grid container>
            <Grid size={{md: 12}} sx={{
                '& > div': {
                    maxWidth: 720 + 50,
                    margin: '10px auto'
                }
            }}>
                <QuillEditorField name={'content'} onChange={autoSubmit} onBlur={handleSubmit} disabled={disabled} fullEditor />
            </Grid>
        </Grid>
    </form>;
}

interface EditorHtmlFormProps {
    stepId: number;
    element: ContentEditorElementIndexResponse;
    versions: VersionsType;
    disabled: boolean;
}

export const EditorHtmlForm = (props: EditorHtmlFormProps) => {

    const {element, disabled} = props;

    const dispatch = useAppDispatch();

    const validate = useCallback((values: HtmlType) => {
        return {};
    }, []);

    const handleSubmit = useCallback(async (values: HtmlType) => {
        console.log("handleSubmit", values);

        const res = await dispatch(updateEditorElement({
            id: String(element.id),
            body: {
                ...element,
                content_html: quillGetValue(values.content)
            }
        }))
        return !isApiResultError(res)

    }, [element, dispatch]);

    return <>
        <Formik
            initialValues={{
                content: quillSetValue(element.content_html)
            }}
            onSubmit={handleSubmit}
            validate={validate}
        >
            {(props) => <EditorHtmlFormFields formikProps={props} disabled={disabled}/>}
        </Formik>
    </>;
}
